import styled from "styled-components";
import { Drawer } from "antd";

export const ButtonsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  button {
    margin-right: 12px;
  }

  button:last-of-type {
    margin-right: 0;
  }
`;

export const FileNameLabel = styled.span`
  margin-left: 12px;
  font-family: "Asap", sans-serif;
  font-size: 0.875rem;
  font-style: italic;
  color: #a5a5a5;
`;

export const Container = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px;
  }
`;

export const DanfeBox = styled.div`
  width: 100%;
  font-family: "Asap", sans-serif;
  font-size: 0.875rem;
  color: #4b4b4b;
`;

export const Section = styled.div`
  border: 1px solid #e8e5e5;
  border-top: none;
  padding: 8px 10px;

  &:first-of-type {
    border-top: 1px solid #e8e5e5;
    border-radius: 6px 6px 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 6px 6px;
  }
`;

export const SectionTitle = styled.div`
  background: #f5f5f5;
  border: 1px solid #e8e5e5;
  border-top: none;
  border-bottom: none;
  padding: 4px 10px;

  font-family: "Asap", sans-serif;
  font-weight: bold;
  font-size: 1.125rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #a5a5a5;
`;

export const FieldsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;

  & + & {
    margin-top: 6px;
  }
`;

export const Field = styled.div`
  flex: ${({ grow }) => grow || 1};
  min-width: 120px;
  padding: 0 8px;

  .fieldLabel {
    font-size: 0.875rem;
    text-transform: uppercase;
    color: #a5a5a5;
  }

  .fieldValue {
    font-size: 0.75rem;
    color: #4b4b4b;
    font-weight: ${({ bold }) => (bold ? "bold" : "normal")};
  }
`;

export const ItemsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem;

  thead th {
    background: #f5f5f5;
    text-align: left;
    padding: 6px 8px;
    font-weight: bold;
    color: #a5a5a5;
    border-bottom: 1px solid #e8e5e5;
  }

  thead th.numeric {
    text-align: right;
  }

  tbody td {
    padding: 6px 8px;
    border-bottom: 1px solid #f0f0f0;
    color: #4b4b4b;
  }

  tbody td.numeric {
    text-align: right;
  }

  tbody td.empty {
    text-align: center;
    color: #a5a5a5;
    padding: 16px 8px;
  }
`;
